/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Max_Cps_Characters_SecInputs */

const en_max_cps_characters_sec = /** @type {(inputs: Max_Cps_Characters_SecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max CPS (Characters/sec)`)
};

const fr_max_cps_characters_sec = /** @type {(inputs: Max_Cps_Characters_SecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPS max (caract./sec)`)
};

const de_max_cps_characters_sec = /** @type {(inputs: Max_Cps_Characters_SecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Klicks pro Sekunde (Zeichen/Sek.)`)
};

const it_max_cps_characters_sec = /** @type {(inputs: Max_Cps_Characters_SecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPS massimo (caratteri/sec)`)
};

const ru_max_cps_characters_sec = /** @type {(inputs: Max_Cps_Characters_SecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальная скорость передачи символов в секунду (CPS)`)
};

const es_max_cps_characters_sec = /** @type {(inputs: Max_Cps_Characters_SecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPS máximo (caracteres/seg)`)
};

const zh_cn2_max_cps_characters_sec = /** @type {(inputs: Max_Cps_Characters_SecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大每秒字符数 (CPS)`)
};

const ja_max_cps_characters_sec = /** @type {(inputs: Max_Cps_Characters_SecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大CPS（文字/秒）`)
};

const hi_max_cps_characters_sec = /** @type {(inputs: Max_Cps_Characters_SecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम सीपीएस (अक्षर/सेकंड)`)
};

const pt_pt2_max_cps_characters_sec = /** @type {(inputs: Max_Cps_Characters_SecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPS máximo (caracteres/seg)`)
};

/**
* | output |
* | --- |
* | "Max CPS (Characters/sec)" |
*
* @param {Max_Cps_Characters_SecInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const max_cps_characters_sec = /** @type {((inputs?: Max_Cps_Characters_SecInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Max_Cps_Characters_SecInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_max_cps_characters_sec(inputs)
	if (locale === "de") return de_max_cps_characters_sec(inputs)
	if (locale === "it") return it_max_cps_characters_sec(inputs)
	if (locale === "ru") return ru_max_cps_characters_sec(inputs)
	if (locale === "es") return es_max_cps_characters_sec(inputs)
	if (locale === "zh-CN") return zh_cn2_max_cps_characters_sec(inputs)
	if (locale === "ja") return ja_max_cps_characters_sec(inputs)
	if (locale === "hi") return hi_max_cps_characters_sec(inputs)
	if (locale === "pt-PT") return pt_pt2_max_cps_characters_sec(inputs)
	return en_max_cps_characters_sec(inputs)
});